import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import classNames from 'classnames';
import Rodal from 'rodal';

import { NOTIFICATION_TYPE } from '../../Constants';
import { sendEmail } from '../../Utils/mailUtil';
import { showNotification } from '../../Utils/otherUtils';

import Checkbox from '../Checkbox';
import FormErrors from '../FormErrors';
import { openGdprModal, closeQuestionModal } from '../../Actions/CareerActions';

import icon from '../../Images/Icons/icon_search_black.svg';

const QuestionModal = (props) => {
  const dispatch = useDispatch();
  const { email } = props;

  const {
    text: { questionModal: pageText },
  } = useSelector(state => state.Language);

  const [isVisible, setIsVisible] = useState(true);
  const [mail, setMail] = useState('');
  const [name, setName] = useState('');
  const [question, setQuestion] = useState('');
  const [acceptGdpr, setAcceptGdpr] = useState(false);
  const [mailError, setMailError] = useState('');
  const [isValid, setIsValid] = useState(false);

  useEffect(() => {
    let mailValid = false;
    if (mail.length > 0) {
      // eslint-disable-next-line no-useless-escape
      mailValid = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,5})+$/.test(mail);
      if (mailValid) {
        setMailError('');
      } else {
        setMailError(pageText.mailInvalid);
      }
    }

    setIsValid(acceptGdpr && mailValid && name !== '' && question !== '');
  }, [mail, name, question, acceptGdpr]);

  const onSubmitForm = () => {
    const parameters = {
      mail,
      name,
      question,
    };
    sendEmail(parameters, email);
    showNotification(
      NOTIFICATION_TYPE.SUCCESS,
      pageText.successToast,
    );
    setIsVisible(false);
  };

  return (
    <div>
      <Rodal
        customStyles={{ height: 'auto', bottom: 'auto', top: '2%' }}
        className="career-modal"
        visible={isVisible}
        leaveAnimation="zoom"
        onAnimationEnd={() => {
          if (!isVisible) {
            dispatch(closeQuestionModal());
          }
        }}
        onClose={() => {
          setIsVisible(false);
        }}
      >
        <div className="career-modal__header">
          <img className="career-modal__icon" src={icon} alt="mail-icon" />
          <h3 className="career-modal__title">{pageText.title}</h3>
        </div>
        <p>
          {pageText.description}
        </p>
        <label className="career-modal__label" htmlFor="name">
          {pageText.name}
          <input
            autoComplete
            id="name"
            name="given-name family-name"
            className="career-modal__input"
            onChange={(e) => {
              setName(e.target.value);
            }}
          />
        </label>
        <label className="career-modal__label" htmlFor="mail">
          {pageText.mail}
          <input
            autoComplete
            id="mail"
            name="mail"
            className="career-modal__input"
            onChange={(e) => {
              setMail(e.target.value);
            }}
          />
        </label>
        <FormErrors formErrors={mailError} />
        <div className="career-modal__divider" />
        <label className="career-modal__label" htmlFor="question">
          {pageText.question}
          <textarea
            className="career-modal__input career-modal__input--block"
            id="question"
            onChange={(e) => { setQuestion(e.target.value); }}
          />
        </label>
        <div className="career-modal__divider" />
        <div
          role="link"
          tabIndex="0"
          className="career-modal__link"
          onClick={() => { dispatch(openGdprModal()); }}
          onKeyPress={() => { dispatch(openGdprModal()); }}
        >
          {pageText.privacy.description}
        </div>
        <Checkbox
          id="gdpr-accept"
          cls="filter-option"
          checked={acceptGdpr}
          onChange={() => { setAcceptGdpr(!acceptGdpr); }}
        >
          {pageText.privacy.accept}
        </Checkbox>
        <button
          className={classNames('career-modal__submit-button')}
          disabled={!isValid}
          onClick={() => { onSubmitForm(); }}
        >
          {pageText.submit}
        </button>
        <button
          className="career-modal__close-button"
          aria-label="close"
          tabIndex="0"
          onClick={() => { setIsVisible(false); }}
        />
      </Rodal>
    </div>
  );
};

export default QuestionModal;



// WEBPACK FOOTER //
// ./src/Components/Career/QuestionModal.js